/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Overlapping_Events_TitleInputs */

const en_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlapping Events`)
};

const fr_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenements qui se chevauchent`)
};

const de_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappende Ereignisse`)
};

const it_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi sovrapposti`)
};

const ru_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пересекающиеся события`)
};

const es_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos superpuestos`)
};

const zh_cn2_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠事件`)
};

const ja_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複するイベント`)
};

const hi_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अतिव्यापी घटनाएँ`)
};

const pt_pt2_editor_overlapping_events_title = /** @type {(inputs: Editor_Overlapping_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos sobrepostos`)
};

/**
* | output |
* | --- |
* | "Overlapping Events" |
*
* @param {Editor_Overlapping_Events_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_overlapping_events_title = /** @type {((inputs?: Editor_Overlapping_Events_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Overlapping_Events_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_overlapping_events_title(inputs)
	if (locale === "de") return de_editor_overlapping_events_title(inputs)
	if (locale === "it") return it_editor_overlapping_events_title(inputs)
	if (locale === "ru") return ru_editor_overlapping_events_title(inputs)
	if (locale === "es") return es_editor_overlapping_events_title(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_overlapping_events_title(inputs)
	if (locale === "ja") return ja_editor_overlapping_events_title(inputs)
	if (locale === "hi") return hi_editor_overlapping_events_title(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_overlapping_events_title(inputs)
	return en_editor_overlapping_events_title(inputs)
});